/**
 * Global error handlers for the application
 * Handles chunk loading errors and other critical failures
 */

// Track if we've already shown an error to avoid spam
let hasShownError = false;
let reloadAttempts = 0;
const MAX_RELOAD_ATTEMPTS = 2;

// Handle chunk loading errors
window.addEventListener('error', (event) => {
  const { message, filename } = event;
  
  // Check if it's a chunk loading error (NOT generic "Load failed")
  const isChunkError = 
    message?.includes('Loading chunk') ||
    message?.includes('Failed to fetch dynamically imported module') ||
    (filename?.includes('.chunk.js') && message?.includes('error'));

  if (isChunkError && !hasShownError && reloadAttempts < MAX_RELOAD_ATTEMPTS) {
    hasShownError = true;
    reloadAttempts++;
    
    console.error('Chunk loading error detected:', {
      message,
      filename,
      timestamp: new Date().toISOString(),
      attempt: reloadAttempts
    });

    // Prevent the error from displaying in the UI
    event.preventDefault();
    event.stopPropagation();

    // Only auto-reload for genuine chunk errors, not generic failures
    if (reloadAttempts < MAX_RELOAD_ATTEMPTS) {
      setTimeout(() => {
        console.log(`Auto-reloading page (attempt ${reloadAttempts}/${MAX_RELOAD_ATTEMPTS})...`);
        // Clear cache and reload
        if ('caches' in window) {
          caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
            window.location.reload(true);
          });
        } else {
          window.location.reload(true);
        }
      }, 1000);
    } else {
      console.error('Max reload attempts reached. Manual intervention required.');
    }
  }
}, true);

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const { reason } = event;
  
  // Only handle genuine chunk loading errors, not generic network failures
  const isGenuineChunkError = 
    reason?.message?.includes('Loading chunk') ||
    reason?.name === 'ChunkLoadError';

  if (isGenuineChunkError && reloadAttempts < MAX_RELOAD_ATTEMPTS) {
    console.warn('Unhandled chunk loading rejection:', reason?.message);
    event.preventDefault(); // Prevent default error handling
    
    // Only auto-reload if we haven't already
    if (!hasShownError) {
      hasShownError = true;
      reloadAttempts++;
      
      if (reloadAttempts < MAX_RELOAD_ATTEMPTS) {
        setTimeout(() => {
          console.log(`Auto-reloading for chunk error (attempt ${reloadAttempts})...`);
          window.location.reload(true);
        }, 1000);
      }
    }
  } else if (reason?.message?.includes('Load failed') || reason?.message?.includes('Failed to fetch')) {
    // Log but don't auto-reload for generic network errors
    console.warn('Network error detected (not auto-reloading):', reason?.message);
    event.preventDefault(); // Suppress error popup
  }
});

// Detect when user is back online
window.addEventListener('online', () => {
  console.log('Network connection restored');
  // Optionally show a toast notification here
});

window.addEventListener('offline', () => {
  console.log('Network connection lost');
  // Optionally show a toast notification here
});

console.log('✅ Global error handlers initialized');
